import React, { SyntheticEvent } from 'react';

import { IconButton } from '@vimeo/bokeh';
import { SearchMagnifier } from '@vimeo/bokeh-icons';
import { translate } from '@vimeo/i18n-runtime';

interface Props {
  onClick: (e?: SyntheticEvent<HTMLButtonElement>) => void;
  'data-testid'?: string;
}

export function SearchToggle({ ...props }: Props) {
  return (
    <IconButton
      aria-label={translate('Search')}
      id="searchToggle"
      icon={<SearchMagnifier />}
      variant="minimal"
      size={{ base: 'sm', sm: 'md' }}
      {...props}
    />
  );
}
